export default "__VITE_ASSET__8e7cf3f0__"